






















import { mapActions, mapGetters } from 'vuex'
import { navigateTo } from '@/router'
import { validate } from '@/services/password'
import PublicPageContent from '@/components/PublicPageContent.vue'
import PasswordSetupForm from './PasswordSetupForm.vue'
import PasswordSetupLinkExpired from './PasswordSetupLinkExpired.vue'
import WithThemeTitle from '@/components/WithThemeTitle.vue'

export default {
  components: {
    WithThemeTitle,
    PublicPageContent,
    PasswordSetupForm,
    PasswordSetupLinkExpired
  },
  props: {
    personId: { type: String, required: true },
    uid: { type: String, required: true },
    token: { type: String, required: true }
  },
  data() {
    return {
      submitting: false
    }
  },
  computed: {
    ...mapGetters(['tokenIsValid'])
  },
  async created() {
    await this.checkResetLinkExpiration({
      personId: this.personId,
      token: this.token
    })
  },
  methods: {
    ...mapActions([
      'sendNewForgottenPassword',
      'checkResetLinkExpiration',
      'sendPasswordResetEmail',
      'invalidateToken'
    ]),
    validatePassword(password) {
      return validate(this.personId, password)
    },
    async submitNewPassword(passwords) {
      this.submitting = true
      try {
        await this.sendNewForgottenPassword({
          uid: this.uid,
          token: this.token,
          ...passwords
        })
        navigateTo('/login')
      } catch (error) {
        this.invalidateToken()
      } finally {
        this.submitting = false
      }
    },
    async sendNewLink() {
      navigateTo('/auth/forgot-password')
    }
  }
}
